"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CustomCurrency = /** @class */ (function () {
    function CustomCurrency(options) {
        if (options === void 0) { options = {}; }
        this.symbol = options.symbol;
        this.insertSpaceInPattern = options.insertSpaceInPattern;
        this.formatPattern = options.formatPattern;
    }
    return CustomCurrency;
}());
exports.default = CustomCurrency;
